import { uniqueCountSymbol } from 'utils/useTableWithCountQuery'
import { createRequestInterceptor } from '../createInterceptor'

export const onlyCountInterceptor = createRequestInterceptor((_queryArgs) => (config) => {
  if (config.data && uniqueCountSymbol in config.data && config.data[uniqueCountSymbol] === 1) {
    config.params = {
      ...config.params,
      only_count: 1,
    }
  }
  return config
})
